import $ from "jquery";

var statusforward     = {},
	mainMenuButtonClass = 'menu-toggle',
	subMenuButtonClass  = 'sub-menu-toggle';

statusforward.init = function() {
	var toggleButtons = {
		menu : $( '<button />', {
			'class' : mainMenuButtonClass,
			'aria-expanded' : false,
			'aria-pressed' : false,
			'role' : 'button'
			} )
			.append( statusforward.params.mainMenu + '<div class="toggle hamburger"><div class="menu-bar"></div><div class="menu-bar"></div><div class="menu-bar"></div></div>' ),
		submenu : $( '<button />', {
			'class' : subMenuButtonClass,
			'aria-expanded' : false,
			'aria-pressed' : false,
			'role' : 'button'
			} )
			.append( $( '<span />', {
				'class' : 'screen-reader-text',
				text : statusforward.params.subMenu
			} ) )
	};
	$( '.nav-primary' ).before( toggleButtons.menu ); // add the main nav buttons
	$( 'nav .sub-menu' ).before( toggleButtons.submenu ); // add the submenu nav buttons
	// $( '.' + mainMenuButtonClass ).each( _addClassID );
	$( '.' + mainMenuButtonClass).addClass('w-nav-button');
	// $( window ).on( 'resize.statusforward', _doResize ).triggerHandler( 'resize.statusforward' );
	$( '.' + mainMenuButtonClass ).on( 'click.statusforward-mainbutton', _mainmenuToggle );

	// Decide whether top level nav items are clickable or should toggle.
	//toggleOptionsByWindowSize();

};

function toggleOptionsByWindowSize() {

		$( '.' + subMenuButtonClass ).on( 'click.statusforward-subbutton', _submenuToggle );
		$( '.menu-item-has-children' ).on( 'click.statusforward-subbutton', _submenuToggleListItem );
}

// add nav class and ID to related button
function _addClassID() {
	var $this = $( this ),
		nav   = $this.next( 'nav' ),
		id    = 'class';
	$this.addClass( $( nav ).attr( 'class' ) );
	if ( $( nav ).attr( 'id' ) ) {
		id = 'id';
	}
	$this.attr( 'id', 'mobile-' + $( nav ).attr( id ) );
}

// Change Skiplinks and Superfish
function _doResize() {
	var buttons = $( 'button[id^=mobile-]' ).attr( 'id' );
	if ( typeof buttons === 'undefined' ) {
		return;
	}
	_superfishToggle( buttons );
	_changeSkipLink( buttons );
	_maybeClose( buttons );
}

/**
 * action to happen when the main menu button is clicked
 */
function _mainmenuToggle() {
	var $this = $( this );
	_toggleAria( $this, 'aria-pressed' );
	_toggleAria( $this, 'aria-expanded' );
	$this.next( 'nav, .sub-menu' ).slideToggle( 400 );
	$this.toggleClass( 'activated' ).toggleClass('w--open');
}

/**
 * Action for submenu toggles (BUTTON).
 * Use when top menu items are active links.
 */
function _submenuToggle() {

	var $this  = $( this ),
		others = $this.closest( '.menu-item' ).siblings();
	_toggleAria( $this, 'aria-pressed' );
	_toggleAria( $this, 'aria-expanded' );
	$this.toggleClass( 'activated' ).toggleClass('w--open');
	$this.next( '.sub-menu' ).slideToggle( 'fast' );

	others.find( '.' + subMenuButtonClass ).removeClass( 'activated' ).removeClass( 'w--open' ).attr( 'aria-pressed', 'false' );
	others.find( '.sub-menu' ).slideUp( 'fast' );

}

/**
 * Action for submenu toggles ( Full Link & Button )
 * Use when parent menu item is a dead link.
 */
function _submenuToggleListItem() {

	var $this  = $( this ),
		children = $this.children(),
		subMenuToggle = $this.find('.sub-menu-toggle');
	_toggleAria( subMenuToggle, 'aria-pressed' );
	_toggleAria( subMenuToggle, 'aria-expanded' );
	subMenuToggle.toggleClass( 'activated' );
	$this.find( '.sub-menu' ).slideToggle( 'fast' );

	$( '.' + subMenuButtonClass ).not($this.children( '.' + subMenuButtonClass )).removeClass( 'activated' ).attr( 'aria-pressed', 'false' );
	$('.menu-item-has-children .sub-menu' ).not($this.children( '.sub-menu' )).slideUp( 'fast' );

}

/**
 * activate/deactivate superfish
 */
function _superfishToggle( buttons ) {
	if ( typeof $( '.js-superfish' ).superfish !== 'function' ) {
		return;
	}
	if ( 'none' === _getDisplayValue( buttons ) ) {
		$( '.js-superfish' ).superfish( {
			'delay': 100,
			'animation': {'opacity': 'show', 'height': 'show'},
			'dropShadows': false
		});
	} else {
		$( '.js-superfish' ).superfish( 'destroy' );
	}
}

/**
 * modify skip links to match mobile buttons
 */
function _changeSkipLink( buttons ) {
	var startLink = 'genesis-nav',
		endLink   = 'mobile-genesis-nav';
	if ( 'none' === _getDisplayValue( buttons ) ) {
		startLink = 'mobile-genesis-nav';
		endLink   = 'genesis-nav';
	}
	$( '.genesis-skip-link a[href^="#' + startLink + '"]' ).each( function() {
		var link = $( this ).attr( 'href' );
		link = link.replace( startLink, endLink );
		$( this ).attr( 'href', link );
	});
}

function _maybeClose( buttons ) {
	if ( 'none' !== _getDisplayValue( buttons ) ) {
		return;
	}
	$( '.menu-toggle, .sub-menu-toggle' )
		.removeClass( 'activated' )
		.attr( 'aria-expanded', false )
		.attr( 'aria-pressed', false );
	$( 'nav, .sub-menu' )
		.attr( 'style', '' );
}

/**
 * generic function to get the display value of an element
 * @param  {id} $id ID to check
 * @return {string}     CSS value of display property
 */
function _getDisplayValue( $id ) {
	var element = document.getElementById( $id ),
		style   = window.getComputedStyle( element );
	return style.getPropertyValue( 'display' );
}

/**
 * Toggle aria attributes
 * @param  {button} $this     passed through
 * @param  {aria-xx} attribute aria attribute to toggle
 * @return {bool}           from _ariaReturn
 */
function _toggleAria( $this, attribute ) {
	$this.attr( attribute, function( index, value ) {
		return _ariaReturn( value );
	});
}

/**
 * update aria-xx value of an attribute
 * @param  {aria-xx} value passed from function
 * @return {bool}
 */
function _ariaReturn( value ) {
	return 'false' === value ? 'true' : 'false';
}

$(document).ready(function () {
	statusforward.params = typeof StatusforwardL10n === 'undefined' ? '' : StatusforwardL10n;

	if ( typeof statusforward.params !== 'undefined' ) {
		statusforward.init();
	}
});